import MonthSelector from './components/MonthSelector.vue';
import NSRComponent from './components/NSRComponent.vue';
import NSRForecastTypeEnum from '../NSRForecastTypeEnum';
import featureFlagsService from '@/app/shared/services/featureFlagsService.js'
import features from "@/app/shared/AppFeatures.js"

export default {
  components: {
    MonthSelector,
    NSRComponent
  },
  data() {
    return {
      projectId: null,

      selectedMonth: new Date(),
      forecastTypes: NSRForecastTypeEnum, // No definition needed, just the enum

      annualRefreshing: false,
      monthlyRefreshing: false
    }
  },
  mounted() {
    this.projectId = Number(this.$store.state.projectId);
  },
  watch: {
    annualRefreshing() {
      this.handleCardRefresh();
    },
    monthlyRefreshing() {
      this.handleCardRefresh();
    }
  },
  computed: {
    formattedMonth() {
      return this.selectedMonth.toLocaleString('default', { month: 'long', year: 'numeric' });
    },
    featureNsrEnabled() {
      return featureFlagsService.isEnabled(features.Core.ProjectFilter.Nsr)
    }
  },
  methods: {
    refreshAnnual() {
      this.annualRefreshing = true;
    },
    stopRefreshAnnual() {
      this.annualRefreshing = false;
    },
    refreshMonthly() {
      this.monthlyRefreshing = true;
    },
    stopRefreshMonthly() {
      this.monthlyRefreshing = false;
    },

    handleCardRefresh() {
      if (this.annualRefreshing || this.monthlyRefreshing) {
        this.$vs.loading();
        return;
      }

      if (!(this.annualRefreshing) && !(this.monthlyRefreshing)) {
        this.$vs.loading.close();
      }
    }

  }
}